import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Container.html?raw';

import BottomTable from './Table';
import "./Table";

import TabContainer from '../../../../../moreCore/UI/Tabbing/TabContainer';
import "../../../../../moreCore/UI/Tabbing/TabContainer";

import _WidgetBaseSP from 'more/_WidgetBaseSP';

class Container extends compose(_WidgetBaseSP) {
    templateString: any = template;
    stages_today: MdsLax<InstanceType<typeof BottomTable>>;
    stages_all: MdsLax<InstanceType<typeof BottomTable>>;
    tabContainer: MdsLax<InstanceType<typeof TabContainer>>;
    

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);


    }

    _onClick_stages_today__ActionBtn_Refresh() {
        this.stages_today.table.url = window.appRoot + "TransportIntermodal/GetDispoStages";
        this.stages_today.table.loadDataResponse({
            "dispoDate": this.dateToLocalISOString(new Date())
        });
    }

    _onClick_stages_all__ActionBtn_Refresh() {
        this.stages_all.table.url = window.appRoot + "TransportIntermodal/GetDispoStages";
        this.stages_all.table.loadDataResponse({
            "dispoDate": null
        });
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.tabContainer.createContextButton(this.stages_today, {
            label: "aktualisieren",
            placement: "top",
            iconClass: "fa fa-refresh",
            permanent: false,
            callback: lang.hitch(this, this._onClick_stages_today__ActionBtn_Refresh)
        });

        this.tabContainer.createContextButton(this.stages_all, {
            label: "aktualisieren",
            placement: "top",
            iconClass: "fa fa-refresh",
            permanent: false,
            callback: lang.hitch(this, this._onClick_stages_all__ActionBtn_Refresh)
        })

        this.RequestManager.handleAs = "json";
        this._onClick_stages_today__ActionBtn_Refresh();

        this._onClick_stages_all__ActionBtn_Refresh();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(Container);